import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import './utStyle.css';
import config from '../../config.json';
import UTLabel from './utLabel';

const apiUrl = config.apiUrl;

const UTApproved = () => {
    const [undertimeData, setUndertimeData] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        DateStart: '',
        DateEnd: '',
        Duration: '',
        Remarks: '',
        Status: '',
    });

    const { undertimeId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchUndertimeData = async () => {
            if (!undertimeId) return;

            setIsDisable(true);

            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${apiUrl}/Undertime/${undertimeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch undertime data');
                    setSuccessMessage('');
                    return;
                }

                const data = await response.json();
                setUndertimeData({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                });

                setIsDisable(false);
            } catch (error) {
                setErrorMessage('Error fetching undertime da');
                setSuccessMessage('');
                setIsDisable(false);
            }
        };

        fetchUndertimeData();
    }, []);

    const handleInputChange = (e) => {
        setUndertimeData({ ...undertimeData, [e.target.name]: e.target.value });
    };

    const handleForSubmit = async (e) => {
        e.preventDefault();

        // Disable the button when the API process starts
        setIsDisable(true);

        const { Remarks } = undertimeData;

        const approvedUndertime = {
            Remarks,
        };

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Undertime/Approve/${undertimeId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(approvedUndertime),
            });

            const data = await response.json();

            if (!response.ok) {
                setErrorMessage('Approve error!');
                setSuccessMessage('');
                return;
            }

            setErrorMessage('');
            setSuccessMessage(data.Message);

            setIsDisable(false);

            navigate('/undertime-list');
        } catch (error) {
            setErrorMessage('Error approval');
            setSuccessMessage('');
            setIsDisable(false);
        }
    };

    const {
        TransactionID,
        TransactionDate,
        Employee,
        DateStart,
        DateEnd,
        Duration,
        Remarks,
        Status,
    } = undertimeData;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasApprover) ? (
                <>
                    <h3>Approve Undertime</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleForSubmit}>
                        <div className="row mt-4">
                            <UTLabel label="Transaction ID" value={TransactionID} />
                            <UTLabel label="Transaction Date" value={TransactionDate} />
                            <UTLabel label="Employee" value={Employee.Name} />
                            <UTLabel label="Date Start" value={DateStart} />
                            <UTLabel label="Date End" value={DateEnd} />
                            <UTLabel label="Duration" value={Duration} />
                            <UTLabel label="Status" value={Status} />
                            <div className="mb-2">
                                <label htmlFor="remarks" className="form-label bold-label">Remarks</label>
                                <input
                                    type="text"
                                    className="form-control custom-width"
                                    id="remarks"
                                    name="Remarks"
                                    value={Remarks}
                                    onChange={handleInputChange}
                                    maxLength={500}
                                />
                            </div>
                            <div className="mb-2">
                                <Link to="/undertime-list" className="btn btn-secondary me-2">Back</Link>
                                {(userAccess.hasApprover || userAccess.hasAdmin) && (
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isDisable} // Disable the button based on the isApproving state
                                    >
                                        Approve
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default UTApproved;
